<template>
  <div
    class="modal fade subscription-modal"
    id="subscriptionModal"
    tabindex="-1"
    aria-labelledby="subscriptionModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="closeButton"
          ></button>
        </div>
        <div class="modal-body">
          <div v-if="tariffs['yearly'].length && tariffs['monthly'].length">
            <div class="toggle">
              <button
                :class="{ active: type === 'monthly' }"
                @click="setType('monthly')"
              >
                в месяц
              </button>
              <button
                :class="{ active: type === 'yearly' }"
                @click="setType('yearly')"
              >
                в год
              </button>
            </div>
          </div>
          <div class="container">
            <div
              class="plan-card"
              v-for="plan in tariffs[type]"
              :key="plan.name"
              :class="plan.name"
            >
              <h2 class="plan-title">Покупка тарифа {{ plan.name }}</h2>
              <div class="plan-price-with-old-price" v-if="plan.old_price">
                <div class="price-wrap">
                  <span class="price">{{ plan.price }}</span>
                  <span v-if="plan.discount" class="discount-badge"
                    >-{{ plan.discount }}%</span
                  >
                </div>
                <span class="old-price">{{ plan.old_price }}</span>
                <span class="suffix">{{ formatPrice(plan) }}</span>
              </div>
              <div class="plan-price" v-else>
                <span class="price">{{ plan.price }}</span>
                <span class="suffix">{{ formatPrice(plan) }}</span>
              </div>
              <div class="plan-checkbox">
                <input class="checkbox" type="checkbox" v-model="autoPayment" />
                <label class="checkbox-label"> Подключить автоплатеж </label>
              </div>
              <label class="plan-agreement">
                Нажимая кнопку Подключить тариф, я принимаю и соглашаюсь с
                <a href="/agreement.pdf" target="_blank" rel="noopener"
                  >условиями оферты</a
                >
              </label>
              <button class="plan-btn" @click="handlePay">
                {{ getButtonText(plan.name) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, defineComponent, onMounted } from "vue";
import { Modal } from "bootstrap";

export default defineComponent({
  name: "BuyASubscriptionModal",
  emits: ["pay"],
  setup(props, { emit }) {
    let type = ref("yearly");
    const tariffs = ref({
      monthly: [],
      yearly: [],
    });
    const autoPayment = ref(false);
    let modalInstance = null;

    const openModal = ({ monthlyPlan, yearlyPlan }) => {
      tariffs.value.monthly = monthlyPlan ? [monthlyPlan] : [];
      tariffs.value.yearly = yearlyPlan ? [yearlyPlan] : [];

      type.value = "yearly";
      autoPayment.value = false;

      if (modalInstance) {
        modalInstance.show();
      }
    };

    const formatPrice = (plan) => {
      if (!plan) return "";

      if (plan.type === "monthly") {
        return "₽ / месяц";
      }

      if (plan.type === "yearly") {
        return "₽";
      }

      return "₽";
    };

    const getButtonText = (planName) => {
      if (planName == "Business" || planName == "Business на год")
        return "Начать сейчас";
      else if (planName == "Premium" || planName == "Premium на год")
        return "Подключить Premium";
    };

    const setType = (value) => {
      type.value = value;
    };

    const currentPlan = computed(() => {
      const list = tariffs.value[type.value] || [];
      return list[0] || null;
    });

    const handlePay = () => {
      if (!currentPlan.value) return;
      emit("pay", {
        plan: currentPlan.value,
        auto_payment: autoPayment.value,
      });
      if (modalInstance) modalInstance.hide();
    };

    onMounted(() => {
      const modalElement = document.getElementById("subscriptionModal");
      if (modalElement) {
        modalInstance = new Modal(modalElement);
      } else {
        console.error("Модальное окно не найдено");
      }
    });

    return {
      type,
      tariffs,
      openModal,
      setType,
      handlePay,
      getButtonText,
      formatPrice,
      autoPayment,
    };
  },
});
</script>

<style scoped lang="scss">
.modal-dialog {
  max-width: 400px;
  margin: auto;
}

.toggle {
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 4px;
  border-radius: 999px;
  background: #f2f3f5;
  margin: 0 auto 24px;
  width: fit-content;
  gap: 4px;
}

.toggle button {
  border: none;
  background: transparent;
  padding: 8px 24px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  color: #8f8f8f;
  cursor: pointer;
  white-space: nowrap;
}

.toggle button.active {
  background: #ffffff;
  color: #333333;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
}

.toggle button:focus {
  outline: none;
  box-shadow: none;
}

.container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 32px;
}

.plan-card {
  background: white;
  border-radius: 30px;
  padding: 32px;
  width: 340px;
  display: flex;
  flex-direction: column;
  box-shadow: 6px 8px 24px 0px rgba(45, 46, 45, 0.2);

  &.Free {
    border: 1px solid rgba(0, 199, 130, 1);
  }

  &.Business {
    border: 1px solid rgba(0, 153, 255, 1);
  }

  &.Premium {
    border: 1px solid rgba(212, 175, 55, 1);
  }

  &.Free .plan-title {
    background: linear-gradient(180deg, #00c782 0%, #00613f 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  &.Business .plan-title {
    background: linear-gradient(90deg, #0099ff 0%, #005c99 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  &.Premium .plan-title {
    background: linear-gradient(180deg, #d4af37 0%, #6e5b1d 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .plan-title {
    font-size: 35px;
    font-weight: 700;
    margin-bottom: 8px;
  }

  .plan-price {
    font-size: 36px;
    font-weight: bold;
    display: flex;
    align-items: center;
    gap: 8px;

    .price {
      font-size: 60px;
    }
    .suffix {
      font-size: 18px;
      font-weight: 700;
      display: block;
      margin-top: 4px;
    }
  }

  .plan-price-with-old-price {
    padding-top: 20px;
    font-weight: bold;
    display: flex;
    // align-items: baseline;
    gap: 12px;
    align-items: center;

    .price-wrap {
      position: relative;
    }

    .discount-badge {
      position: absolute;
      padding-left: 100px;
      top: -18px;
      background: #e74c3c;
      color: #fff;
      font-size: 14px;
      line-height: 1;
      padding: 6px 10px;
      border-radius: 5px;
      white-space: nowrap;
    }

    .price {
      font-size: 35px;
    }

    .old-price {
      font-size: 25px;
      color: #8f8f8f;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        left: -2px;
        right: -2px;
        top: 50%;
        height: 2px;
        background: currentColor;
        transform: translateY(-50%);
        opacity: 0.9;
      }
    }
    .suffix {
      font-size: 20px;
    }
  }

  .plan-btn {
    margin-top: 40px;
    padding: 12px 24px;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    border: none;
  }

  &.Free .plan-btn {
    background: linear-gradient(90deg, #00c782 0%, #00613f 100%);
    color: #fff;
  }

  &.Business .plan-btn {
    background: linear-gradient(90deg, #0099ff 0%, #005c99 100%);
    color: #fff;
  }

  &.Premium .plan-btn {
    background: linear-gradient(90deg, #d4af37 0%, #6e5b1d 100%);
    color: #fff;
  }
}

.plan-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 16px 0;
  cursor: pointer;
}

.plan-checkbox .checkbox {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 2px solid #000;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
}
/* галочка */
.plan-checkbox .checkbox::after {
  content: "";
  width: 10px;
  height: 6px;
  border-left: 2px solid #ffffff;
  border-bottom: 2px solid #ffffff;
}
.plan-checkbox .checkbox:checked {
  background: #27a56b;
  border-color: #27a56b;
}

.plan-checkbox .checkbox:checked::after {
  transform: rotate(-45deg) scale(1);
}

.plan-checkbox .checkbox-label {
  font-size: 20px;
}

.plan-agreement {
  font-size: 15px;
  color: #666;
  font-weight: 400;
  max-width: 100%;
}

.plan-agreement a {
  color: #2f80ed;
  text-decoration: none;
}
</style>
